import { render, staticRenderFns } from "./callDoorphoneDialog.vue?vue&type=template&id=13a3c9b2&scoped=true"
import script from "./callDoorphoneDialog.vue?vue&type=script&lang=js"
export * from "./callDoorphoneDialog.vue?vue&type=script&lang=js"
import style0 from "./callDoorphoneDialog.vue?vue&type=style&index=0&id=13a3c9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3c9b2",
  null
  
)

export default component.exports